import {
    debounce,
    addClass,
    removeClass,
    stripLocation,
    onlyAllowNumbers,
} from './_utilities';

// show spinner
const showSpinner = (el) => {
    // remove span text, icon and show svg spinner
    const buttonWidth = el.offsetWidth;
    removeClass(el, 'button--hide-spinner');
    addClass(el, 'button--show-spinner');
    el.style.width = `${buttonWidth}px`;
};

// hide spinner
const hideSpinner = (el) => {
    removeClass(el, 'button--show-spinner');
    addClass(el, 'button--hide-spinner');
};

// display "zip invalid" error
const showZipInvalidError = (zipForm) => {
    // hide spinner
    const zipFormSubmitButton = zipForm.querySelector('button[type="submit"]');
    const formErrorEl = zipForm.querySelector('.form-error');
    const formInputEl = zipForm.querySelector('input[type=tel]');

    hideSpinner(zipFormSubmitButton);
    addClass(formErrorEl, 'is-visible');
    addClass(formInputEl, 'is-invalid-input');
    formErrorEl.innerHTML = 'Please enter a valid zip code.';
};

// check zip code against MAPI
const externalZipCheck = (zip, zipForm) => {
    const link = `/wp/wp-admin/admin-ajax.php?action=zipcheck&zip=${zip}`;
    fetch(link, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
    })
        .then((res) => res.json()) // parse response as JSON (can be res.text() for plain response)
        .then((response) => {
            if (response.valid) {
                // zip is valid
                // used to forward users to #both from blog pages
                const filterHash = zipForm.getAttribute('data-filter-hash');
                const redirectUrl = zipForm.getAttribute('data-redirect-url');
                let hash = window.location.hash;
                if (filterHash !== null) {
                    hash = `#${filterHash}`;
                }
                const submitToOrigin = zipForm.getAttribute(
                    'data-submit-to-origin'
                ); // used for Dynamic Geo Location

                if (submitToOrigin === 'true') {
                    // used for Dynamic Geo Location (used on Xfinity pages above Package Cards)
                    const newLocation = stripLocation(window.location.href);
                    window.location.href = `${newLocation}?zip=${zip}#change_location`;
                } else if (redirectUrl !== null) {
                    // forward to redirect url
                    window.location.href = `${redirectUrl}?zip=${zip}${hash}`;
                } else {
                    // console.log(`forwarding to: /compare-providers?zip=${zip}${hash}`);
                    window.location.href = `/compare-providers?zip=${zip}${hash}`;
                }
            } else {
                // zip is invalid (did not validate against MAPI)
                showZipInvalidError(zipForm);
            }
        })
        .catch((err) => {
            console.log('Error: ', err);
            if (err.status === 404) {
                showZipInvalidError(zipForm);
            } else {
                console.error(`Status: ${err}`);
            }
        });

    $.ajax({
        dataType: 'json',
        url: `/api/mapi/?zip=${zip}&a=validate`,
        success: (response) => {
            if (response.valid) {
                // zip is valid
                // used to forward users to #both from blog pages
                const filterHash = zipForm.getAttribute('data-filter-hash');
                const redirectUrl = zipForm.getAttribute('data-redirect-url');
                let hash = window.location.hash;
                if (filterHash !== null) {
                    hash = `#${filterHash}`;
                }
                const submitToOrigin = zipForm.getAttribute(
                    'data-submit-to-origin'
                ); // used for Dynamic Geo Location

                if (submitToOrigin === 'true') {
                    // used for Dynamic Geo Location (used on Xfinity pages above Package Cards)
                    const newLocation = stripLocation(window.location.href);
                    window.location.href = `${newLocation}?zip=${zip}#change_location`;
                } else if (redirectUrl !== null) {
                    // forward to redirect url
                    window.location.href = `${redirectUrl}?zip=${zip}${hash}`;
                } else {
                    // console.log(`forwarding to: /compare-providers?zip=${zip}${hash}`);
                    window.location.href = `/compare-providers?zip=${zip}${hash}`;
                }
            } else {
                // zip is invalid (did not validate against MAPI)
                showZipInvalidError(zipForm);
            }
        },
        error: (response, textStatus, errorThrown) => {
            // zip is invalid, display form error
            if (response.status === 404) {
                showZipInvalidError(zipForm);
            } else {
                console.error(
                    `Status: ${textStatus}, Error Thrown: ${errorThrown}`
                );
            }
        },
    });
};

// Handle response data
const handleResponse = (response, zip, zipForm) => {
    // Bind to first array index for easy reference
    const firstIndex = response.data.validateZipCode.cities[0];

    if (typeof firstIndex !== 'undefined') {
        const submitToOrigin = zipForm.getAttribute('data-submit-to-origin'); // used for Dynamic Geo Location

        // If the validated provider response has AOA, state and city data (from DB) then redirect safely knowing the
        // '/ST/City' path can be established successfully
        if (firstIndex.state !== null && firstIndex.city !== null) {
            const filterHash = zipForm.getAttribute('data-filter-hash');
            const redirectUrl = zipForm.getAttribute('data-redirect-url');
            let hash = window.location.hash;
            if (filterHash !== null) {
                hash = `#${filterHash}`;
            }

            if (submitToOrigin === 'true') {
                // used for Dynamic Geo Location
                // console.log('submitToOrigin detected');
                const newLocation = stripLocation(window.location.href);
                /* eslint-disable */
                window.location.href = `${newLocation}?zip=${zip}#change_location`;
                /* eslint-enable */
            } else if (redirectUrl !== null) {
                // forward to redirect url
                window.location.href = `${redirectUrl}?zip=${zip}${hash}`;
            } else {
                // console.log(`forwarding to: /${response[0].state}/${response[0].city}?zip=${zip}${hash}`);
                window.location.href = `/${firstIndex.state}/${firstIndex.city}?zip=${zip}${hash}`;
            }
        } else {
            // If zip fails to validate against local DB (no non-satellite providers returned), attempt an external zip check
            // to validate the zip submitted. If it's valid, then we'll just return the satellite providers
            // on the /compare-providers page.

            externalZipCheck(zip, zipForm);
        }
    } else {
        // console.log('no preliminary response');

        // hide spinner
        const zipFormSubmitButton = zipForm.querySelector(
            'button[type="submit"]'
        );
        hideSpinner(zipFormSubmitButton);
    }
};

// Check zip against local DB
const checkZip = (zipCode, zipForm) => {
    const link = `/wp/wp-admin/admin-ajax.php?action=zipcheck&zip=${zipCode}`;
    fetch(link, {
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
    })
        .then((res) => res.json()) // parse response as JSON (can be res.text() for plain response)
        .then((response) => {
            if (response.errors) {
                // hide spinner
                const zipFormSubmitButton = zipForm.querySelector(
                    'button[type="submit"]'
                );
                hideSpinner(zipFormSubmitButton);
                // shows invalid zip message
                const formErrorEl =
                    zipFormSubmitButton.parentElement.parentElement.querySelector(
                        '.form-error'
                    );
                addClass(formErrorEl, 'is-visible');
                formErrorEl.innerHTML = 'Please enter a valid zip code.';
            } else {
                handleResponse(response, zipCode, zipForm);
            }
        })
        .catch((err) => {
            console.log(err);

            // hide spinner
            const zipFormSubmitButton = zipForm.querySelector(
                'button[type="submit"]'
            );
            hideSpinner(zipFormSubmitButton);
        });
};

// Push events for Optimizely tracking
const pushOptimizelyEvents = (zip) => {
    window.optimizely = window.optimizely || [];
    window.optimizely.push(['trackEvent', `zip_${zip}`]);
};

// Push form location for GTA tracking
const pushFormLocation = (location) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'form-location': location,
    });
};

// Handle zip form submission
const submitForm = debounce(
    (e) => {
        // Stop default form behavior
        e.preventDefault();

        // Bind to form elements
        const zipForm = e.target;
        const zipFormSubmitButton = zipForm.querySelector(
            'button[type="submit"]'
        );
        const zipInputEl = zipForm.elements.zipcode;
        const zipValue = zipInputEl.value;
        const formLocation = zipForm.getAttribute('data-form-location');

        // show spinner
        showSpinner(zipFormSubmitButton);

        // If we don't have a value, just highlight the input field
        if (!zipValue || zipValue.length < 5) {
            showZipInvalidError(zipForm);
            zipInputEl.focus();
            hideSpinner(zipFormSubmitButton);
        } else {
            document.cookie = 'zipFinder=true; expires=0; path=/';

            // Broadcast Optimizely events
            pushOptimizelyEvents(zipValue);

            // push GTA form location
            pushFormLocation(formLocation);

            // Attempt to validate zip, first locally and then remotely upon local failure
            checkZip(zipValue, zipForm);
        }
    },
    1000,
    true
);

// Module startup
const init = () => {
    // Determine module to load based off of script tag data attribute
    const zipFormArray = Array.prototype.slice.call(
        document.querySelectorAll('[data-zip-form]')
    ); // on generic pages
    const zipFinderArray = Array.prototype.slice.call(
        document.querySelectorAll('[data-zip-finder]')
    ); // on blog pages
    const allZipForms = zipFormArray.concat(zipFinderArray);

    // Check to make sure we have zip forms on page
    if (allZipForms !== null && allZipForms.length > 0) {
        // Loop/map through all zip form elements
        Array.prototype.map.call(allZipForms, (el) => {
            // Disallow characters entered into zip input
            const inputElement = el.querySelector('input');
            if (inputElement) {
                onlyAllowNumbers(inputElement);
            }

            // Add submit event listener for each form
            $(el).on('submit', submitForm);
        });
    }
};

export { init };
